import { render } from "./TeacherView.vue?vue&type=template&id=dfd8b590&scoped=true"
import script from "./TeacherView.vue?vue&type=script&lang=js"
export * from "./TeacherView.vue?vue&type=script&lang=js"

import "./TeacherView.vue?vue&type=style&index=0&id=dfd8b590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd8b590"]])

export default __exports__